
<template>
  <div class="index">
    <!-- <Header ref="header" title="操作说明" :back="true" left="" /> -->
    <div class="box">
       <h1 style="text-align:center;margin-top:12px;font-size:18px">操作说明</h1>
       <div class="box_item">
         <span class="step_num">
             第一步：
         </span>
         <div>
                登录PC端中国国际贸易单一窗口
                <div class="blod">网址：www.singlewindow.cn</div>
         </div>
       </div>
       <div class="box_item">
         <span class="step_num">
             第二步：
         </span>
         <div>
                登录单一窗口后，点击顶部 <span class="blod"> “用户名”</span>
         </div>
       </div>
        <div class="">
                <img class="image" src="@/views/image/userregister/option1.png" alt="" srcset="">
        </div>
       <div class="box_item">
         <span class="step_num">
             第三步：
         </span>
         <div>
                点击用户管理下的 <span class="blod"> “登录凭证管理”</span>
         </div>
       </div>
        <div class="">
                <img class="image" src="@/views/image/userregister/option2.png" alt="" srcset="">
        </div>
       <div class="box_item">
         <span class="step_num">
             第四步：
         </span>
         <div>
                 <span class="blod"> 启用手机号/邮箱登录</span>
         </div>
       </div>
        <div class="">
                <img class="image" src="@/views/image/userregister/option3.png" alt="" srcset="">
        </div>
       
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {
  Form,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Field,
  Col,
  Row,
  Button,
  Picker,
  Popup,
  Toast,
  DatetimePicker,
  NoticeBar,
} from "vant";

export default {
  name: "option",
  computed: {
   
  },
  data() {
    return {
      statusBar: 0,
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
  },

  methods: {

  },

  components: {
    Header,
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [DatetimePicker.name]: DatetimePicker,
    [NoticeBar.name]: NoticeBar,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
.index {
  box-sizing: border-box;
  height: 100%;
  background: #fff;
}
.image{
    width: 100%;
    margin-top: 8px;
}
.box{
    box-sizing: border-box;
    padding: 0 20px;
    color: #333;
}
.blod{
    font-weight: bolder;
}
.step_num{
    flex-shrink: 0;
}
.box_item{
    display: flex;
    margin-top: 30px;
    line-height: 24px;
}
</style>